export default __webpack_public_path__ + "static/media/maybank.55aecca0.svg";